import React from "react";
import useStore from "context";

export const SidebarBadge = ({ name }) => {
  const {
    branchRequestsUnseenCount,
    goodRequestsUnseenCount,
    usersUnseenCount,
    messagesUnseenCount,
    paymentOrdersPendingCount,
  } = useStore();

  if (name === "Payment orders" && paymentOrdersPendingCount) {
    return (
      <span className="unresolved_count">{paymentOrdersPendingCount}</span>
    );
  }

  if (name === "Branch requests" && branchRequestsUnseenCount) {
    return (
      <span className="unresolved_count">{branchRequestsUnseenCount}</span>
    );
  }

  if (name === "Goods requests" && goodRequestsUnseenCount) {
    return <span className="unresolved_count">{goodRequestsUnseenCount}</span>;
  }

  if (name === "Users" && usersUnseenCount) {
    return <span className="unresolved_count">{usersUnseenCount}</span>;
  }

  if (name === "Messages" && messagesUnseenCount) {
    return <span className="unresolved_count">{messagesUnseenCount}</span>;
  }

  return <></>;
};
